import { Box, Text, Textarea } from '@chakra-ui/react';

interface CommentsSectionProps {
  comments: string;
  onChange: (value: string) => void;
}

const CommentsSection = ({ comments, onChange }: CommentsSectionProps) => {
  return (
    <Box>
      <Text fontWeight="bold" fontSize="md" mb={2}>
        Comments
        <Text as="span" color="red.500">
          *
        </Text>
      </Text>
      <Text fontSize="sm" color="gray.600" mb={3}>
        You must provide a detailed rationale or justification for the referral.
      </Text>
      <Textarea
        value={comments}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Please provide detailed remarks explaining the reason(s) for your referral."
        rows={6}
        resize="vertical"
      />
    </Box>
  );
};

export default CommentsSection;
